<template>
  <b-overlay :show="this.show" rounded="lg">
    <b-card :bg-variant="(this.dueornot===1)?'warning':'dark'" text-variant="white" class="mb-0" style="border-radius:16px">
      <b-card-title class="mb-0">
        <b-row align-h="between" align-v="start">
          <b-col class="ml-2">
            <b-row><h4 class="font-weight-bold">{{this.card.bank}}</h4></b-row>
            <b-row><h5 class="text-muted small">{{this.card.codename}}</h5></b-row>
          </b-col>
          <b-col class="text-right pr-1 touchable" @click="reveal_full_cid()">**** {{this.card.cid.slice(-4)}}</b-col>
        </b-row>
      </b-card-title>
      <b-card-text @click="reveal_overlay()">
        <h1 class="my-2 balance" :class="{'text-danger':this.card.balance<0}">{{this.commafy(this.card.balance)}}￥</h1>
      </b-card-text>
      <b-card-text class="small text-muted">{{(this.card.overdraft_max>0)?"可透支":"不可透支"}} {{(this.dueornot===1)?"有透支未还":""}} {{(this.loanStatus)?`有金额为${this.loanStatus.amount}￥的贷款`:""}}</b-card-text>
    </b-card>
    <template v-slot:overlay>
      <b-row class="w-100 mx-0" align-h="center">
          <b-icon icon="box-arrow-in-down-left" font-scale="3" class="m-1 touchable" @click="actions('deposit')"></b-icon>
          <b-icon icon="box-arrow-up-right" font-scale="3" class="m-1 touchable" @click="actions('withdraw')"></b-icon>
          <b-icon icon="arrow-left-right" font-scale="3" class="m-1 touchable" @click="actions('transfer')"></b-icon>
          <b-icon icon="file-earmark-text" font-scale="3" class="m-1 touchable" v-if="card.loan_max!==0&&!card.lid" @click="actions('loan')"></b-icon>
          <b-icon icon="file-check" font-scale="3" class="m-1 touchable" v-if="card.loan_max!==0&&card.lid" @click="actions('pay_loan')" ></b-icon>
          <b-icon icon="x" font-scale="3" variant="danger" class="m-1 touchable" @click="show = false"  ></b-icon>
      </b-row>
    </template>
  </b-overlay>
</template>

<style scoped>
  *, *:before, *:after {
    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  }
  .balance{
    white-space: nowrap;  
    /* text-overflow:ellipsis;  */
    overflow:auto;
    cursor: pointer;
  }

  .touchable{
    cursor: pointer;
  }
</style>

<script>
import {store} from './store'
import {urls} from '../components/urls'

export default {
  name:'Card',
  mixins: [urls],
  props:['card','Nmode','lock'],
  data:function(){
      return{
        // nightmode:false,
        storeData:store.state,
        show:false
      }
  },
  methods: {
    commafy:function(num){
        let str = num.toString().split('.');
        if (str[0].length >= 5) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join('.');
    },
    UTC2Local:function(date){
      date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
      let result='';
      result=date.getFullYear().toString()+'-';
      if((date.getMonth()+1).toString().length==1)result+='0';
      result+=(date.getMonth()+1).toString()+'-';
      if(date.getDate().toString().length==1)result+='0';
      result+=date.getDate().toString()+' ';
      if(date.getHours().toString().length==1)result+='0';
      result+=date.getHours().toString()+':';
      if(date.getMinutes().toString().length==1)result+='0';
      result+=date.getMinutes().toString()+':';
      if(date.getSeconds().toString().length==1)result+='0';
      result+=date.getSeconds().toString();
      return result
    },
    simplifyTime(date){
      let result='';
      let current=new Date();
      if(current.getFullYear() !== date.getFullYear()){
        result=date.getFullYear().toString()+'-';
      }
      if((date.getMonth()+1).toString().length==1)result+='0';
      result+=(date.getMonth()+1).toString()+'-';
      if(date.getDate().toString().length==1)result+='0';
      result+=date.getDate().toString()+' ';
      if(date.getHours().toString().length==1)result+='0';
      result+=date.getHours().toString()+':';
      if(date.getMinutes().toString().length==1)result+='0';
      result+=date.getMinutes().toString(); //+':';
      // if(date.getSeconds().toString().length==1)result+='0';
      // result+=date.getSeconds().toString();
      return result
    },
    actions(type){
      this.$emit('actions',{type:type,cid:this.card.cid,card:this.card});
      this.show=false;
    },
    close_overlay:function(){
      this.show=false;
    },
    reveal_overlay:function(){
      if(this.lock)return 1
      this.show=true;
      setTimeout(this.close_overlay, 5000 );
      return 0
    },
    reveal_full_cid:async function(){
      if(navigator.clipboard){
        const res=await navigator.clipboard.writeText(this.card.cid).then(res=>res);
        this.$bvToast.toast(this.card.cid, {
          title: `完整卡号已复制到你的剪贴板`,
          toaster: 'b-toaster-bottom-center',
          variant: 'info',
          solid: true,
          appendToast: true
        })
      }else{
        this.$bvToast.toast(this.card.cid, {
          title: `完整卡号无法复制到你的剪贴板，请手动复制`,
          toaster: 'b-toaster-bottom-center',
          variant: 'warning',
          solid: true,
          appendToast: true
        })
      }
    },
  },
  computed:{
    displayMode(){
      if(this.Nmode){
        return {
          bg:"dark",
          text:"muted"
        }
      }
      return {
        bg:"light",
        text:""
      }
    },
    dueornot(){
      if(!this.card.due)return 2;
      const current=Date.now(),due=Date.parse(this.card.due);
      if(due-current<0){
        return 1
      }
      return 0
    },
    loanStatus(){
      if(!this.card.lid)return null;
      return {start_date:this.card.start_date,amount:this.card.amount}
    }
  }
}
</script>

